import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/src/avatar-placeholder.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/Avatar/premium.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/ExternalLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NextImage/NextImageWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/helpers/errorHandling/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageCatchesGrid"] */ "/app/src/views/Page/components/PageCatchesGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageFeed"] */ "/app/src/views/Page/components/PageFeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageFollowButton"] */ "/app/src/views/Page/components/PageFollowButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/Page/Page.module.css");
